"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiddenChats = void 0;
const IGroupChats_1 = require("./IGroupChats");
const models_1 = require("../../models");
class HiddenChats extends IGroupChats_1.IGroupChats {
    getChatsStorage() {
        return this.hhnStorage.chatsStorage;
    }
    getGroupType() {
        return models_1.GROUP_TYPE.HIDDEN;
    }
}
exports.HiddenChats = HiddenChats;
